<div class="relative">
  <!-- Bell Button -->
  <button
    id="notification-bell-button"
    (click)="togglePanel()"
    class="btn btn-ghost btn-circle relative"
    [class.btn-active]="showPanel"
    [attr.aria-expanded]="showPanel"
    [attr.aria-label]="unreadCount > 0 ? 'Benachrichtigungen (' + unreadCount + ' ungelesen)' : 'Benachrichtigungen'"
    aria-controls="notification-panel"
    aria-haspopup="true">
    <i class="fas fa-bell text-xl" aria-hidden="true"></i>

    <!-- Unread Badge -->
    @if (unreadCount > 0) {
      <span
        class="absolute top-1 right-1 badge badge-error badge-xs min-w-[1.25rem] h-5 text-xs font-bold"
        [attr.aria-label]="unreadCount + ' ungelesene Benachrichtigungen'">
        {{ unreadCount > 99 ? '99+' : unreadCount }}
      </span>
    }
  </button>

  <!-- Notification Panel -->
  @if (showPanel) {
    <app-notification-panel
      id="notification-panel"
      (closePanel)="closePanel()">
    </app-notification-panel>
  }
</div>

<!-- Click outside to close -->
@if (showPanel) {
  <div
    class="fixed inset-0 z-40"
    (click)="onClickOutside($event)">
  </div>
}
